import axios from 'axios';

export const postSignup = async (username: string, password: string, password_confirm: string) => {
  const BACKEND_API = process.env.REACT_APP_BACKEND_BASE!;
  const api = `${BACKEND_API}auth/register/`;
  const data = await axios.post(api, { "username": username, "email": username, "password": password, "password_confirm": password_confirm });
  return data.data;
};
